import IntlMessageFormat from 'intl-messageformat';

function orDocLocale(maybeLocale) {
    // must not be null, undefined is OK
    return maybeLocale || document.getElementsByTagName('html')[0].getAttribute('lang') || undefined;
}

function getUnformattedMessageForCode(dictionary = window.ScreenMessages, code) {
    return (dictionary || {})[code] || code;
}

export function messageTemplate(template, ...args) {
    return args.reduce((msg, arg, idx) => msg.replace('#[' + idx + ']', arg), template);
}

/**
 * Marker function used to used to require the inclusion of an i18n (regular) message.
 * Calls are detected, handled, and removed during a static code analysis
 * (see jspack.js).
 *
 * @param _codePattern a message code or code pattern, for instance: "admin.section.*"
 */
export function requireMessage(_codePattern) {
    // if this function were empty, it would be automatically deleted by webpack before we could even use it as a marker
    return _codePattern;
}

// We don't need to actually export this function as we're only using installI18n one
// But we never know, maybe we'll have to use regularMessage directly
export function regularMessage(dictionary, code, ...args) {
    let msg = getUnformattedMessageForCode(dictionary, code);
    msg = msg.replace(/''/g, "'");

    const maybesArgArray = args[0];
    if (Array.isArray(maybesArgArray)) {
        args = maybesArgArray;
    }

    args.forEach((arg, idx) => {
        msg = msg.replace(new RegExp('\\{' + idx + '}', 'g'), arg);
    });

    return msg;
}

// We don't need to actually export this function as we're only using installI18n one
// But we never know, maybe we'll have to use icuMessage directly
export function icuMessage(dictionary, code, argHash, maybeLocales) {
    const msg = getUnformattedMessageForCode(dictionary, code);
    let mf;

    try {
        mf = new IntlMessageFormat(msg, orDocLocale(maybeLocales));
    } catch (err) {
        console.error(err);
        return msg;
    }

    try {
        return mf.format(argHash || {});
    } catch (e) {
        console.error(e);
        return msg;
    }
}

export function installI18n(dictionary) {
    return {
        msg: (code, ...args) => regularMessage(dictionary, code, ...args),
        icuMsg: (code, args, maybeLocale) => icuMessage(dictionary, code, args, maybeLocale),
        messageTemplate: (template, ...args) => messageTemplate(template, ...args),
        requireMessage: (codePattern) => requireMessage(codePattern),
    };
}
